var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarehouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.008 512.008",
    style: {
      enableBackground: "new 0 0 512.008 512.008"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M491.127,155.041l-230.4-153.6c-2.867-1.92-6.596-1.92-9.463,0l-230.4,153.6c-2.372,1.587-3.797,4.25-3.797,7.1v341.333    c0,4.719,3.823,8.533,8.533,8.533h460.8c4.71,0,8.533-3.814,8.533-8.533V162.14C494.933,159.299,493.508,156.628,491.127,155.041z     M477.866,494.94H34.133V166.714L255.999,18.806l221.867,147.908V494.94z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M431.052,154.827L260.386,52.504c-2.697-1.613-6.076-1.613-8.772,0L80.947,154.827c-3.294,1.963-4.864,5.897-3.84,9.591    c1.024,3.695,4.395,6.255,8.226,6.255h341.333c3.84,0,7.202-2.551,8.226-6.255C435.916,160.724,434.338,156.79,431.052,154.827z     M116.164,153.607l139.836-83.84l139.844,83.84H116.164z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M418.133,221.874H93.866c-4.71,0-8.533,3.814-8.533,8.533v273.067c0,4.719,3.823,8.533,8.533,8.533h324.267    c4.71,0,8.533-3.814,8.533-8.533V230.407C426.666,225.688,422.843,221.874,418.133,221.874z M409.6,494.94H102.4v-256h307.2    V494.94z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M263.142,3.864c-2.586-3.942-7.876-5.043-11.819-2.466L3.857,163.531c-3.942,2.586-5.043,7.876-2.458,11.819    c1.63,2.5,4.361,3.857,7.142,3.857c1.604,0,3.226-0.444,4.676-1.391L260.684,15.683C264.627,13.097,265.728,7.806,263.142,3.864z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M508.151,163.531L260.684,1.398c-3.951-2.577-9.233-1.476-11.819,2.466c-2.586,3.942-1.485,9.233,2.458,11.819    L498.79,177.816c1.442,0.939,3.063,1.391,4.668,1.391c2.782,0,5.513-1.357,7.151-3.857    C513.194,171.408,512.093,166.117,508.151,163.531z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M435.2,187.74h-358.4c-4.71,0-8.533,3.814-8.533,8.533v34.133c0,4.719,3.823,8.533,8.533,8.533h358.4    c4.71,0,8.533-3.814,8.533-8.533v-34.133C443.733,191.555,439.91,187.74,435.2,187.74z M426.666,221.874H85.333v-17.067h341.333    V221.874z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M349.866,426.674H238.933c-4.71,0-8.533,3.814-8.533,8.533v68.267c0,4.719,3.823,8.533,8.533,8.533h110.933    c4.71,0,8.533-3.814,8.533-8.533v-68.267C358.4,430.488,354.577,426.674,349.866,426.674z M341.333,494.94h-93.867v-51.2h93.867    V494.94z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M307.2,375.474h-51.2c-4.71,0-8.533,3.814-8.533,8.533v51.2c0,4.719,3.823,8.533,8.533,8.533h51.2    c4.71,0,8.533-3.814,8.533-8.533v-51.2C315.733,379.288,311.91,375.474,307.2,375.474z M298.666,426.674h-34.133V392.54h34.133    V426.674z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M384,358.407h-76.8c-4.71,0-8.533,3.814-8.533,8.533v68.267c0,4.719,3.823,8.533,8.533,8.533h34.133v59.733    c0,4.719,3.823,8.533,8.533,8.533H384c4.71,0,8.533-3.814,8.533-8.533V366.94C392.533,362.221,388.71,358.407,384,358.407z     M375.466,494.94H358.4v-59.733c0-4.719-3.823-8.533-8.533-8.533h-34.133v-51.2h59.733V494.94z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M315.733,426.674h-42.667c-4.71,0-8.533,3.814-8.533,8.533v34.133c0,4.719,3.823,8.533,8.533,8.533h42.667    c4.71,0,8.533-3.814,8.533-8.533v-34.133C324.266,430.488,320.443,426.674,315.733,426.674z M307.2,460.807h-25.6V443.74h25.6    V460.807z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M213.333,290.14h-42.667c-4.71,0-8.533,3.814-8.533,8.533v34.133c0,4.719,3.823,8.533,8.533,8.533h42.667    c4.71,0,8.533-3.814,8.533-8.533v-34.133C221.866,293.955,218.043,290.14,213.333,290.14z M204.799,324.274h-25.6v-17.067h25.6    V324.274z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M196.266,426.674h-102.4c-4.71,0-8.533,3.814-8.533,8.533v68.267c0,4.719,3.823,8.533,8.533,8.533h102.4    c4.71,0,8.533-3.814,8.533-8.533v-68.267C204.799,430.488,200.977,426.674,196.266,426.674z M187.733,494.94H102.4v-51.2h85.333    V494.94z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M255.999,290.14H128c-4.71,0-8.533,3.814-8.533,8.533v136.533c0,4.719,3.823,8.533,8.533,8.533h59.733v59.733    c0,4.719,3.823,8.533,8.533,8.533h42.667c4.71,0,8.533-3.814,8.533-8.533V443.74h8.533c4.71,0,8.533-3.814,8.533-8.533V298.674    C264.533,293.955,260.71,290.14,255.999,290.14z M247.466,426.674h-8.533c-4.71,0-8.533,3.814-8.533,8.533v59.733h-25.6v-59.733    c0-4.719-3.823-8.533-8.533-8.533h-59.733V307.207h110.933V426.674z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M213.333,76.807c-4.71,0-8.533,3.814-8.533,8.533v76.8c0,4.719,3.823,8.533,8.533,8.533c4.71,0,8.533-3.814,8.533-8.533    v-76.8C221.866,80.621,218.043,76.807,213.333,76.807z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M298.666,76.807c-4.71,0-8.533,3.814-8.533,8.533v76.8c0,4.719,3.823,8.533,8.533,8.533s8.533-3.814,8.533-8.533v-76.8    C307.2,80.621,303.377,76.807,298.666,76.807z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/warehouse.796e2ad37f2fe21884c60c97c0b49cbe.svg";
export { ForwardRef as ReactComponent };